import { render, staticRenderFns } from "./AdminFollowerCityChart.vue?vue&type=template&id=08bee0f2&"
import script from "./AdminFollowerCityChart.vue?vue&type=script&lang=js&"
export * from "./AdminFollowerCityChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports